<!--设置各列数据对应关系-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">

          <div width="100%" style="text-align: center;font-size:20px;margin-top: 20px;">
            <div style="text-align: center;font-size:20px;margin-bottom: 10px;font-weight: bold;">
              选择查询条件</div>

            <div style="margin-top: 10px;">
              <div style="font-size: 14px;"><span
                  style="margin-bottom: 10px;">*请从左框中查询条件列(如姓名,身份证等,最多两个)选到右侧框中:</span></div>
              <div style="font-size: 14px;margin-top: 5px;"><span
                  style="color:red;margin-bottom: 10px;">特别注意:必须选择每个人都有数据的列,否则部分人将无法查询</span></div>
              <div style="text-align: left;display: flex;justify-content: center;margin-top: 10px;">
                <el-transfer v-model="selectedCondition" :data="transferList" :titles="['可选的列','已选的列']"></el-transfer>
              </div>
            </div>

            <div style="margin-top: 20px;" v-if="selectedCondition.length>0">
              <div style="font-size: 20px;color:red;margin-top: 10px;">
                <el-checkbox v-model="show_public"><span style="color:red;font-size: 16px;">{{showPublicTips()}}</span>
                </el-checkbox>
              </div>
            </div>

            <div style="padding: 10px;text-align: center;">
              <div style="padding: 10px;text-align: center;display: flex;justify-content: center;">
                <!-- <el-button type="primary" size="medium" plain @click="backToList">暂不设置</el-button> -->
                <el-button type="primary" size="medium" @click="saveConfiguration">设置无误,开始导入数据！</el-button>
              </div>
            </div>

          </div>

        </div>

      </el-col>
    </el-row>

    <el-dialog title="重要提示" :visible.sync="dialogVisible" width="30%">
      <span>

        <div>
          {{message}}
        </div>

      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="primary">好 的</el-button>
      </span>
    </el-dialog>

    <el-dialog title="操作确认" :visible.sync="setConditionConfirmVisible" width="40%">
      <span>

        <div>
          查询人需要录入<span style="color:red;font-weight: bold;">{{selected_column_names}}</span>才能查询，确定吗?
        </div>

      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setConditionConfirmVisible = false">取消</el-button>
        <el-button @click="confirmImport" type="primary">确定,立即导入</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        username: '',
        form_name: '',
        form_id: '',
        form_comment: '',
        dataList: [],
        headList: [],

        transferList: [],
        selectedCondition: [],

        input_pages: '',
        import_data: '',
        dialogVisible: false,
        message: '',
        show_public: false,
        is_public: 0,

        setConditionConfirmVisible: false,
        selected_column_names: ''
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

      this.loadTransferList()
    },
    methods: {
      saveConfiguration() {
        if (this.selectedCondition.length === 0) {
          // this.$message.error('至少需要选择一个列用做领表凭证')
          this.message = '至少选一个供填表人输入的列的内容,如编号、姓名等，否则导入的数据填表人无法正确领取修改和填写。'
          // this.dialogVisible = true
          this.$message.error(this.message)
          return
        }

        if (this.selectedCondition.length > 2) {
          this.message = '至少选一个供填表人输入的列的内容但不要超过两个,否则填写会比较麻烦,如编号、姓名等，否则导入的数据填表人无法正确领取修改和填写。'
          this.$message.error(this.message)
        }

        // if (this.selectedCondition.length > 2) {
        //   this.$message.error('最多选择两个列哦')
        //   return
        // }

        this.setConditionConfirmVisible = true

        /* let that = this

         var requestUrl = '/form/web/_save_valid_configuration.jsp'
         // 开启loading

         // 开启loading
         const load = this.$loading({
           lock: true,
           text: 'Loading',
           spinner: 'el-icon-loading',
           background: 'rgba(0, 0, 0, 0.7)'
         })

         var jsonStr = JSON.stringify(that.selectedCondition)

         if (this.show_public === true) {
           this.is_public = 1
         } else {
           this.is_public = 0
         }

         let data = {
           form_id: that.form_id,
           conditions: jsonStr,
           is_public: that.is_public
         }

         var qs = require('qs')

         this.axios.post(
             requestUrl,
             qs.stringify(data), {
               headers: {
                 'Content-Type': 'application/x-www-form-urlencoded'
               }
             }
           ).then(function(response) {
             if (response.data.result === '1') {
               that.$message.success('保存成功！')
               that.$router.push({
                 path: '/form_list',
                 params: {
                   username: that.username
                 }
               })
             }

           })
           .catch(function(error) {
             console.log(error)
             load.close()
           }) */
      },
      back() {
        this.$router.back()
      },
      backToList() {
        let that = this
        that.$router.push({
          path: '/query_list',
          params: {
            username: that.username
          }
        })
      },
      loadTransferList() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/wansearch/web/_load_transfer_field_list.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.form_id
            }
          }).then(function(response) {
            that.transferList = []
            let items = response.data.formFields
            for (var i = 0; i < items.length; i++) {
              var tmpLabel = items[i].field_name + '(' + items[i].valued_count + '条)'
              let item = {
                key: items[i].field_name,
                label: tmpLabel,
                disabled: false
              }
              that.transferList.push(item)
            }

            that.selectedCondition = []
            let selectedItems = response.data.selecteFormFields
            for (var j = 0; j < selectedItems.length; j++) {
              // let selectedItem = {
              //   key: selectedItems[j].field_name,
              //   label: selectedItems[j].field_name
              // }
              that.selectedCondition.push(selectedItems[j].condition_name)
            }

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      showPublicTips() {
        let that = this

        var tempstr = ''

        var tstr = ''

        for (var i = 0; i < that.selectedCondition.length; i++) {
          if (i === 0) {
            tstr = that.selectedCondition[0]
          } else {
            tstr = tstr + '、' + that.selectedCondition[0]
          }
        }

        if (tstr !== '') {
          tstr = '"' + tstr + '"'
        }

        this.selected_column_names = tstr

        tempstr = '公开' + tstr + '条件的值,便于领表人选入查询条件(不涉及隐私时使用)'

        return tempstr
      },
      confirmImport() {
        this.setConditionConfirmVisible = false

        let that = this

        var requestUrl = '/wansearch/web/_save_query_configuration.jsp'
        // 开启loading

        // 开启loading


        var jsonStr = JSON.stringify(that.selectedCondition)

        if (this.show_public === true) {
          this.is_public = 1
        } else {
          this.is_public = 0
        }

        console.log('*******************',this.is_public)

        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        let data = {
          form_id: that.form_id,
          conditions: jsonStr,
          is_public: that.is_public
        }

        var qs = require('qs')

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            if (response.data.result === '1') {
              that.$message.success('保存成功！')
              that.$router.push({
                path: '/query_list',
                params: {
                  username: that.username
                }
              })
            }
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .rowTipStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .settingRowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid aliceblue;
    margin: 5px;
  }

  .rowContentStyle {
    display: flex;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .settingFormStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .titleBarStyle {
    display: flex;
  }

  .columnTitleStyle {
    display: flex;
    flex-direction: column;
  }

  .colStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .paperShowStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/set_query_condition.vue